/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Kits_Own_TitleInputs */

const en_simple_kits_own_title = /** @type {(inputs: Simple_Kits_Own_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your own idea`)
};

const id_simple_kits_own_title = /** @type {(inputs: Simple_Kits_Own_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan idemu sendiri`)
};

/**
* | output |
* | --- |
* | "Describe your own idea" |
*
* @param {Simple_Kits_Own_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_kits_own_title = /** @type {((inputs?: Simple_Kits_Own_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Kits_Own_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_kits_own_title(inputs)
	return en_simple_kits_own_title(inputs)
});